import { Button } from "@/components/ui/button";
import ConfirmActionDialog from "./ConfirmActionDialog";
import { useConfirmedAction } from "./useConfirmedAction";

interface TestAllButtonProps {
  writable: boolean;
  /** How many waiting models can be tested here. */
  count: number;
  /** A test is already running. */
  busy: boolean;
  onRunAll: () => Promise<unknown>;
}

const CONFIRM_TEXT =
  "This tests every model that is waiting, one after another. Each test takes a few minutes and costs a few cents to a couple of dollars in AI usage. Continue?";

const TestAllButton = ({ writable, count, busy, onRunAll }: TestAllButtonProps) => {
  const action = useConfirmedAction(onRunAll);
  if (!writable || count < 1) return null;
  return (
    <>
      <Button size="sm" variant="outline" disabled={busy} onClick={() => action.setOpen(true)}>
        Test all
      </Button>
      <ConfirmActionDialog
        open={action.open}
        onOpenChange={action.setOpen}
        title="Test all waiting models?"
        description={CONFIRM_TEXT}
        confirmLabel="Yes, test all"
        pending={action.pending}
        onConfirm={action.confirm}
      />
    </>
  );
};

export default TestAllButton;
